// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export type AuthMode = 'COT' | 'IDP';

export interface Environment {
  production: boolean;
  AUTH_MODE: AuthMode;
  ISSUER: 'https://login.microsoftonline.com/a9e6a0e7-fbc4-4701-96c9-b832b342dbf1/v2.0',
  REDIRECT_URI: 'https://qwyn-poc.gcp.qwyn-dev.com',
  CLIENT_ID: 'aea292bc-abc7-42f7-bef6-6a767bc14fdf',
  SCOPE: 'openid profile api://aea292bc-abc7-42f7-bef6-6a767bc14fdf/sso_application',
  RESPONSE_TYPE: string;
  QWYNUI_URL: 'https://qwyn-poc.gcp.qwyn-dev.com',
  QMAAPI_URL: 'https://api.qwyn-poc.gcp.qwyn-dev.com',
  TIMEOUT_FACTOR: number;
  AG_GRID_LICENSE: 'Using_this_{AG_Grid}_Enterprise_key_{AG-072261}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Delta_Capita_Software_Services_Holding,_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Qwyn}_only_for_{4}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Qwyn}_need_to_be_licensed___{Qwyn}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{21_November_2025}____[v3]_[01]_MTc2MzY4MzIwMDAwMA==efe18b57cd259cd8de016e3ca2b2290e',
  RELEASE_NOTES_REDIRECT_URI: 'https://qwyn-poc.gcp.qwyn-dev.com',
  ACTIVE_DIRECTORY_AVAILABLE_FOR_SUGGESTIONS: true,
  ACTIVE_DIRECTORY_CLIENT_ID: 'aea292bc-abc7-42f7-bef6-6a767bc14fdf',
  ACTIVE_DIRECTORY_TENANT_ID: 'a9e6a0e7-fbc4-4701-96c9-b832b342dbf1',
  ACTIVE_DIRECTORY_SCOPE: 'openid profile User.Read.All Group.Read.All',
  ACTIVE_DIRECTORY_USERS_API_URL: 'https://graph.microsoft.com/v1.0/users',
  ACTIVE_DIRECTORY_GROUPS_API_URL: 'https://graph.microsoft.com/v1.0/groups',
  ORGANIZATION_NAME: 'Delta Capita',
  APP_NAME: 'Qwyn',
  SYMPHONY_APP_ID: '',
  SYMPHONY_APP_NAME: '',
  TINY_MCE_LICENSE_KEY: 'T7LK051EA90F8880850AAC3E3B6035F68F3DB0D940476E0803266A0CF113C636',
  QWYN_AUTH_API_URL: 'https://auth.qwyn-poc.gcp.qwyn-dev.com',
  strictDiscoveryDocumentValidation: boolean;
}

export const environment: Environment = {
  production: false,
  AUTH_MODE: 'IDP',

  // OAuth2/OIDC configuration (used when AUTH_MODE === 'IDP') — Okta
  ISSUER: 'https://login.microsoftonline.com/a9e6a0e7-fbc4-4701-96c9-b832b342dbf1/v2.0',
  REDIRECT_URI: 'https://qwyn-poc.gcp.qwyn-dev.com',
  CLIENT_ID: 'aea292bc-abc7-42f7-bef6-6a767bc14fdf',
  SCOPE: 'openid profile api://aea292bc-abc7-42f7-bef6-6a767bc14fdf/sso_application',
  RESPONSE_TYPE: 'code',
  QWYNUI_URL: 'https://qwyn-poc.gcp.qwyn-dev.com',
  QMAAPI_URL: 'https://api.qwyn-poc.gcp.qwyn-dev.com',
  TIMEOUT_FACTOR: 0.80,

  // Licensing / release configuration
  AG_GRID_LICENSE: 'Using_this_{AG_Grid}_Enterprise_key_{AG-072261}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Delta_Capita_Software_Services_Holding,_LLC}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Qwyn}_only_for_{4}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Qwyn}_need_to_be_licensed___{Qwyn}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{21_November_2025}____[v3]_[01]_MTc2MzY4MzIwMDAwMA==efe18b57cd259cd8de016e3ca2b2290e',
  RELEASE_NOTES_REDIRECT_URI: 'https://qwyn-poc.gcp.qwyn-dev.com',

  // Active Directory configuration
  ACTIVE_DIRECTORY_AVAILABLE_FOR_SUGGESTIONS: true,
  ACTIVE_DIRECTORY_CLIENT_ID: 'aea292bc-abc7-42f7-bef6-6a767bc14fdf',
  ACTIVE_DIRECTORY_TENANT_ID: 'a9e6a0e7-fbc4-4701-96c9-b832b342dbf1',
  ACTIVE_DIRECTORY_SCOPE: 'openid profile User.Read.All Group.Read.All',
  ACTIVE_DIRECTORY_USERS_API_URL: 'https://graph.microsoft.com/v1.0/users',
  ACTIVE_DIRECTORY_GROUPS_API_URL: 'https://graph.microsoft.com/v1.0/groups',
  TINY_MCE_LICENSE_KEY: 'T7LK051EA90F8880850AAC3E3B6035F68F3DB0D940476E0803266A0CF113C636',

  // Organization / branding
  ORGANIZATION_NAME: 'Delta Capita',
  APP_NAME: 'Qwyn',

  // Symphony configuration
  SYMPHONY_APP_ID: '',
  SYMPHONY_APP_NAME: '',
  QWYN_AUTH_API_URL: 'https://auth.qwyn-poc.gcp.qwyn-dev.com',
  strictDiscoveryDocumentValidation: false,
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
